module.exports = __webpack_public_path__ + "img/BLITZ POSITANO-903-retro.17bd3b94.jpg";